import type { RouteObject } from 'react-router';

/**
 * A1. The landing route for every caller who holds `punch:read` **and**
 * `exception:read`; `components/nav.ts` `landingPath()` picks something else
 * for anyone who does not.
 */
export const routes: RouteObject[] = [
  {
    path: '/dashboard',
    lazy: async () => ({ Component: (await import('./DashboardRoute')).DashboardRoute }),
  },
];
